// Fora do componente para o Fast Refresh do Vite: arquivo de componente só exporta componente.
/** Botão "Revisar", que recebe o foco quando a assinatura é cancelada. */
export const ID_BOTAO_REVISAR = 'prescricao-revisar'
